import React from 'react';
import MarkdownRenderer from './MarkdownRenderer';
import { Message } from './useAgentChat';

interface AgentMessageProps {
  message: Message;
}

const formatTime = (date: Date): string => {
  return date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
};

const AgentMessage: React.FC<AgentMessageProps> = ({ message }) => {
  const isUser = message.role === 'user';

  if (isUser) {
    return (
      <div className="agent-msg agent-msg--user">
        <div className="agent-msg__content">{message.content}</div>
        <span className="agent-msg__timestamp">{formatTime(message.timestamp)}</span>
      </div>
    );
  }

  return (
    <div className="agent-msg agent-msg--assistant">
      <div className="agent-msg__content">
        <MarkdownRenderer content={message.content} />
      </div>
      <span className="agent-msg__timestamp">{formatTime(message.timestamp)}</span>
    </div>
  );
};

export default AgentMessage;
